import React from 'react';
import { Switch } from 'react-router-dom';

import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import AccountsSummaryV2 from '../pages/AccountsSummaryV2';
import TransactionsSummaryV2 from '../pages/TransactionsSummaryV2';
import Portfolio from '../pages/Portfolio';
import PortfolioV2 from '../pages/PortfolioV2';
import PortfolioDistribution from '../pages/PortfolioDistribution';
import PortfolioDistributionV2 from '../pages/PortfolioDistributionV2';
import PortfolioAllocation from '../pages/PortfolioAllocation';
import PortfolioAllocationV2 from '../pages/PortfolioAllocationV2';
import AccountsManager from '../pages/AccountsManager';
import Analytics from '../pages/Analytics';

import Route from './Route';
import AccountsV2 from '../pages/AccountsV2';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />
    <Route path="/forgot" component={ForgotPassword} />
    <Route path="/signup" component={SignUp} />
    <Route path="/reset-password" component={ResetPassword} />
    <Route path="/dashboard" component={AccountsSummaryV2} isPrivate />
    <Route
      path="/transactions-summary"
      component={TransactionsSummaryV2}
      isPrivate
    />
    <Route path="/account-manager" component={AccountsManager} isPrivate />
    <Route path="/analytics" component={Analytics} isPrivate />
    <Route path="/accounts" component={AccountsV2} isPrivate />
    <Route path="/portfolio" component={Portfolio} isPrivate />
    <Route path="/portfolio-v2" component={PortfolioV2} isPrivate />
    <Route
      path="/portfolio-distribution"
      component={PortfolioDistribution}
      isPrivate
    />
    <Route
      path="/portfolio-distribution-v2"
      component={PortfolioDistributionV2}
      isPrivate
    />
    <Route
      path="/portfolio-allocation"
      component={PortfolioAllocation}
      isPrivate
    />
    <Route
      path="/portfolio-allocation-v2"
      component={PortfolioAllocationV2}
      isPrivate
    />
  </Switch>
);

export default Routes;
